import { reactive } from 'vue';

export default reactive({
    //loader
    loading: false,
    loadingText: 'Loading ...',
    //authorization of user
    can: {
        'account': false,
        'users' : false,
        'organizations' : false,
        'campaigns' : false, 
        'activity' : false ,
        'research' : false,
        'data' : false,
        'leaderboard' : false,
        'leaderboard.mapping': false,
        'target' : false,
        'health' : false,
        'prospector' : false,
        'quality' : false,
        'report.notarget': false,
    },
    //compose pop up
    composePopup: false,
});